import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('pages/authentication/Register')));
const AuthCreatePin = Loadable(lazy(() => import('pages/authentication/CreatePin')));
const AuthForgotPin = Loadable(lazy(() => import('pages/authentication/ForgotPin')));
const AuthUpdatePin = Loadable(lazy(() => import('pages/authentication/UpdatePin')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'login',
            element: <AuthLogin />
        },
        {
            path: 'register',
            element: <AuthRegister />
        },
        {
            path: 'create-pin',
            element: <AuthCreatePin />
        },
        {
            path: 'forgot-pin',
            element: <AuthForgotPin />
        },
        {
            path: 'update-pin',
            element: <AuthUpdatePin />
        }
    ]
};

export default LoginRoutes;
